module.exports = __webpack_public_path__ + "static/media/painting.2bb6e51e.svg";